import axios from 'axios';
import { setToken, setTokenExpiredTime } from '../../utils/auth';
import axiosRequest from '../axios';

export interface loginRequestBody {
  email: string;
  password: string;
}

export interface loginResponseBody {
  success: boolean;
  data: loginResponseDataBody;
}

export interface loginResponseDataBody {
  accessToken: string;
  expiresIn: number;
  tokenType: string;
}

export default async (detail: loginRequestBody): Promise<any> => {
  try {
    const { data }: { data: loginResponseBody } = await axiosRequest.post('api/nova/login', detail);
    if (data.success) {
      setToken(data.data.accessToken);
      setTokenExpiredTime(data.data.expiresIn);
    }
    return data.success;
  } catch (e) {
    console.error('Error while running login restful API.', e);
    throw e;
  }
};
